import { useEffect, useState, createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import { setServerErrorFn } from 'services/api'

const ServerErrorContext = createContext()

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape()
  ]).isRequired
}

export const ServerErrorContextProvider = ({ children }) => {
  const [serverError, setServerError] = useState(null)

  useEffect(() => {
    setServerErrorFn((errorMessage) => setServerError(errorMessage))
  }, [])

  return (
    <ServerErrorContext.Provider value={{ serverError, setServerError }}>
      {children}
    </ServerErrorContext.Provider>
  )
}

ServerErrorContextProvider.propTypes = propTypes

export const useServerErrorContext = () => useContext(ServerErrorContext)
